import React, {useEffect} from 'react';
import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';
import {useDispatch, useSelector} from 'react-redux';
import {setFluxAnalysisActive} from '../data/reports';
import {Box, Typography} from '@mui/material';

export function FluxSwitch() {
  const dispatch = useDispatch();
  const selectedPeriod = useSelector((state) => state.periods.selectedPeriod);
  const selectedComparePeriod = useSelector(
    (state) => state.periods.selectedComparePeriod
  );
  const fluxAnalysisActive = useSelector(
    (state) => state.reports.fluxAnalysisActive
  );
  const isDisabled = !selectedComparePeriod || !selectedPeriod;

  // Sync the redux state when disabled externally
  useEffect(() => {
    if (isDisabled) {
      dispatch(
        setFluxAnalysisActive({
          fluxAnalysisActive: false,
        })
      );
    }
  }, [isDisabled]);

  async function handleChange() {
    dispatch(
      setFluxAnalysisActive({
        fluxAnalysisActive: !fluxAnalysisActive,
      })
    );
  }

  return (
    <Tooltip
      title={
        isDisabled ? 'Select another period to view Flux analysis.' : undefined
      }
    >
      <Box
        display="flex"
        alignItems="center"
        flexDirection="row"
        flexWrap="nowrap"
      >
        <Switch
          id="flux-analysis-switch"
          disabled={isDisabled}
          checked={fluxAnalysisActive}
          onChange={handleChange}
        />
        <Typography fontWeight={500} as="label" htmlFor="flux-analysis-switch">
          Flux
        </Typography>
      </Box>
    </Tooltip>
  );
}
